// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"styles_formLabel__1sMDJ","roundedInput":"styles_roundedInput__3wFAw"};